import _template from 'lodash/template';

// TODO: [PRO-3634] `displayContent` convention for localization. Turn text to translate into a localization en-US.json
export type DisplayContent = typeof displayContent;
export const displayContent = {
  btnAddCustomFont: 'Add custom font',
  btnBack: 'Back',
  btnCancel: 'Cancel',
  btnClose: 'Close',
  btnClearDataFeeds: 'Clear data feeds',
  btnClearTestMessage: 'Stop displaying',
  btnClearUserData: 'Clear user data',
  btnContent: 'Content',
  btnContinueToReview: 'Continue to review',
  btnDeleteFont: 'Delete font',
  btnDesign: 'Design',
  btnDetails: 'Details',
  btnDisplayMessage: 'Display test message',
  btnEdit: 'Edit details',
  btnEditFont: 'Edit font',
  btnExitPreview: 'Exit preview',
  btnLeaveWithoutSaving: 'Leave without saving',
  btnLoadDataFeeds: 'Load data feeds',
  btnLoadUserData: 'Load user data',
  btnNext: 'Next',
  btnOpenContentEditorSelector: 'Select an editor',
  btnPreferences: 'Preferences',
  btnPreview: 'Preview',
  btnPreviewInNewTab: 'Preview in new tab',
  btnPreviewOnDevices: 'Preview on devices',
  btnSave: 'Save',
  btnSaveAndExit: 'Save and exit',
  btnSaveDesign: 'Save design',
  btnSaveDetailsAndExit: 'Save details and exit',
  btnSaveDesignAndExit: 'Save design & exit',
  btnSaveFont: 'Save font',
  btnSaveSettings: 'Save details',
  btnSelect: 'Select',
  btnSend: _template('Send test <%= isEmail ? `email` : `message` %>'),
  btnSendProof: 'Send proof',
  btnSendTestAsRandom: 'As random users...',
  btnSendTestMsg: 'Send test message',
  btnSendTestToList: 'To an internal list...',
  btnSendTestToOtherAddress: 'To another address...',
  btnSendTestToOtherUuid: 'To another user',
  btnSendTestToSelf: 'To yourself',
  btnSmsSmartOptInDetailsCopy: 'Copy',
  btnSmsSmartOptInDetailsEdit: 'Edit',
  btnSmsSmartOptInFormCancel: 'Cancel',
  btnSmsSmartOptInFormCreateLink: 'Create link',
  btnSmsSmartOptInFormSave: 'Save',
  btnSmsSmartOptInFormHeroBanner: 'Learn more in our docs',
  btnSmsSmartOptInOpenModal: 'SMS Opt-in',
  btnSnippet: 'Snippet',
  btnStartTestMessage: 'Start test message',
  btnUpdateTestMessage: 'Save test message',
  btnView: 'View',
  dataParamsInMessage: 'Save and preview for accurate character count.',
  drawerTitle: 'Details',
  defaultError: 'An unknown error has occurred',
  designHeader: 'Design',
  editDesign: 'Edit design',
  encodingHelpText: "Encoding will be automatically selected based on your message's character set",
  errBlastCampaignMissingAudience:
    'Missing Audience. Please navigate to step 1 setup and make a selection before proceeding to review.',
  errDataFeed: 'Unable to load data feed',
  errDesign: 'Error in design',
  errDragAndDropTemplates: 'Unable to load drag and drop templates',
  errDragAndDropTemplateNA: 'Drag and drop template not found.',
  errFieldIsRequired: _template('<%= fieldName %> is required'),
  errFontNameUnique: 'The font name must be unique',
  errHandlebarsException: 'Check handlebar and user data configurations.',
  errReviewDisabled: 'Fix design and detail errors to review.',
  errSyntax: 'Syntax error',
  errNoTemplateFound: "Oops... we couldn't find that template.",
  errTemplateCorrupted: "Oops... we couldn't find that locale for this template.",
  errTestMessage: _template(
    'Unable to send <%= sendSubject %>. <%= recipient %> <%= recipient.indexOf(`, `) === -1 ? `is` : `are` %> <%= error %>',
  ),
  errNotFound: _template(
    'Unable to send <%= sendSubject %>. <%= recipient %> not found in this project.',
  ),
  errMsgCopyJourneyFromNonBetaToLocalesBeta:
    'Unable to copy the journey. Please select a project not in the locales beta or turn off the option to include campaigns with the copy and try again.',
  errMsgCopyJourneyFromLocalesBetaToNonBeta:
    'Unable to copy the journey. Please select a project in the locales beta or turn off the option to include campaigns with the copy and try again.',
  errPreviewWithData: 'Could not display preview.',
  errSendAbortedException: 'This configurations results in a sendSkip.',
  errTestMessageList: 'Unable to load list options',
  errUpdateCampaignName: 'Unable to save campaign name',
  errUpdateTemplateName: 'Unable to save template name',
  errUpdateTemplateNameEmpty: 'Template name is required',
  errUpdateTemplateNameInvalid: 'Invalid template name',
  errUserData: 'Unable to load user data',
  errViewTemplatePermission: 'Unable to view template',
  gsm7Encoding: 'GSM-7 Encoding',
  handlebarTooltip: 'Insert snippet',
  headerBehavior: 'Behavior',
  headerContent: 'Content',
  headerCustomFontsEmpty: `You'll find your custom fonts here`,
  headerDataFeeds: 'Data feeds',
  headerDetails: 'Details',
  headerDeleteFont: 'Delete font?',
  headerEditFont: 'Edit font',
  headerLinks: 'Links',
  headerNewFont: 'New font',
  headerOpenContentEditorSelector: 'An editor was not selected',
  headerPreferences: 'Preferences',
  headerSaveFont: 'Save font?',
  headerSelectEditorType: 'Select editor type',
  headerSendingInformation: 'Sending Information',
  headerSmsSmartOptInFormAdd: 'Add',
  headerSmsSmartOptInFormHeroBanner: 'Grow your lists with SMS opt-in links',
  headerSmsSmartOptInModal: 'SMS opt-in links',
  headerStyling: 'Styling',
  headerUnsavedChanges: 'Unsaved changes',
  headerUserData: 'User data',
  labelButtonAction: 'Button action',
  labelButtonType: 'Button type',
  labelCampaignName: 'Campaign name',
  labelContentEditor: 'Content editor',
  labelConvertCSS: 'Convert CSS to line styling',
  labelCustomFonts: 'Custom fonts',
  labelDesktop: 'Desktop',
  labelDragDrop: 'Drag and Drop',
  labelEmailContentTextOption:
    'Use a custom plaintext version instead of the automatically generated version',
  labelEmailEditorViewAMP: 'AMP HTML',
  labelEmailEditorViewHTML: 'HTML version',
  labelEmailEditorViewText: 'Plain text',
  labelFontFamily: 'Font family',
  labelFontName: 'Font name',
  labelFontURL: 'Font URL',
  labelFromEmail: 'From email',
  labelFromName: 'From name',
  labelHtmlEditorTheme: 'HTML editor theme',
  labelIdentifier: 'Identifier',
  labelLastSaved: 'Last saved:',
  labelList: 'List',
  labelListName: 'List name',
  labelMediaUrl: 'Media URL',
  labelMessageType: 'Message type',
  labelMobile: 'Mobile',
  labelNewFontName: 'New font name',
  labelPlaceholder: 'Placeholder',
  labelRecipient: 'Recipient',
  labelRecipients: 'Recipients',
  labelSideBySide: 'Side by Side',
  labelSmsSmartOptInDetailsDisclaimer: 'Recommended SMS disclaimer',
  labelSmsSmartOptInDetailsLink: 'SMS opt-in link',
  labelSmsSmartOptInFormBrandName: 'Brand name',
  labelSmsSmartOptInFormDescription: 'Description',
  labelSmsSmartOptInFormMessageType: 'SMS message type',
  labelSmsSmartOptInFormName: 'Name',
  labelSmsSmartOptInFormOptionalText: '(optional)',
  labelSmsSmartOptInFormRedirectLink: 'Redirect link if user is not on their phone',
  labelSmsSmartOptInFormTermsLink: 'SMS disclaimer terms of service link',
  labelSmsSmartOptInFormPrivacyLink: 'SMS disclaimer privacy policy link',
  labelSmsSmartOptInFormSender: 'Send reply to',
  labelSmsSmartOptInPreview: 'Opt-in SMS preview',
  labelStyling: 'Styling',
  labelSubmitButtonText: 'Submit button text',
  labelTemplateName: 'Template name',
  labelTestUsers: 'Test users',
  labelThemeChrome: 'Chrome',
  labelThemeClouds: 'Clouds',
  labelThemeGithub: 'Github',
  labelThemeMonokai: 'Monokai',
  labelThemeTwilight: 'Twilight',
  labelUnsavedChanges: 'There are unsaved changes',
  labelWysiwyg: 'WYSIWYG',
  linkAddCustomFont: 'add a custom font',
  linkBackToTemplates: 'Back to All Templates',
  linkBackToTemplateDefaultLocale: 'Back to the default locale for this template',
  linksSectionDisabledTooltip:
    'To add analytics tracking and link parameters, enable Shorten and track with the checkbox above.',
  linksShorteningDisabledTooltip:
    'Email link shortening is enabled for all templates in this project and cannot be disabled.',
  localesBetaErrorMessage:
    'Unable to copy the template. Please select a project that is not in the locales beta and try again.',
  localesBetaErrorForNonBetaProj: `Unable to copy the template. Please select a project in the locales beta and try again.`,
  localesBetaCloningJourneyErrorMessageToDisplay:
    'Unable to copy the journey. Please select a project not in the locales beta or turn off the option to include campaigns with the copy and try again.',
  mobileInboxStrCharacterLength: _template('<%= charCount %>/<%= charLimit %> characters'),
  placeholderIconUrl: 'https://www.placeholder.com',
  placeholderMediaUrl: 'https://www.iterable.com/image/400',
  placeholderRecipient: 'recipientname@companyname.com',
  placeholderRecipients: 'recipientname@companyname.com, recipientname@companyname.com',
  placeholderRecipientsForUUID: 'Enter user email or ID. Use commas to send to multiple users.',
  placeholderSearchList: 'Search all lists',
  placeholderSelectList: 'Select a list',
  placeholderUrl: 'https://iterable.com',
  placeholderUserEmail: 'Enter user email',
  placeholderUserEmailOrId: 'Enter user email or ID',
  shortenAndTrack:
    'This preview shows a placeholder shortened link. Actual link shortening happens on campaign send.',
  sendTestMessageTooltipContent:
    'To send a test message, tap ‘Review’ and submit template for approval.',
  sendTestMessageWhatsAppPendingTooltipContent:
    'You can send a test message once your template is approved.',
  sendTestMessageWhatsAppRejectedTooltipContent:
    'To send a test message, create a new template and tap ‘Review’ to submit for approval.',
  strAddCustomFont: 'To style your campaigns to match your brand,',
  strAppName: 'App name',
  strActionButtonHelpText: 'Used to identify the button for event tracking.',
  strByteSizeInfo:
    'This email size is an estimate. Emails may increase in size on send and be clipped due to link rewriting.',
  strByteSizeWarning: 'Exceeds 102 kB limit on Gmail and will be clipped.',
  strCharacterLength: _template('<%= charCount %><%= `/100 characters` %>'),
  strCharacterLengthDynamicMaxCount: _template('<%= charCount %> / <%= maxCharCount %> characters'),
  strConfirmDeleteFont:
    'Are you sure you want to delete this font? This cannot be undone and will impact any content that is referencing this font.',
  strConfirmEditFont:
    'Are you sure you want to save changes to this font? This cannot be undone and will impact any content that is referencing this font.',
  strConvertCSS: `Converts CSS styles found in a template's <head> tag to inline styles. Useful for imported templates that contain styles in a <head> tag.`,
  strDataFeedsAdded: _template(
    '<%= feedCount %> data <%= feedCount === 1 ? `feed has` : `feeds have` %> been added',
  ),
  strDataUpdatedSuccessfully: _template('<%= dataName %> updated successfully'),
  strDisplayTestToInternalListTitle: 'Display test message to internal list',
  strDisplayTestToInternalListSubtitle:
    'Display a test message to an internal list to verify your embedded message configuration. We cap message recipients at 50 to prevent accidentally displaying to a production list.',
  strDisplayTestToOtherTitle: 'Display test message to another recipient',
  strDisplayTestToOtherSubtitle:
    'Display a test message to a list of recipients entered below. We cap message recipients at 50 to prevent accidentally displaying to a production list.',
  strDisplayTestToSelfTitle: 'Display test message to yourself',
  strEditorLevelAdvancedText: 'Advanced HTML level',
  strEditorLevelBeginnerText: 'Beginner HTML level',
  strEditorLevelIntermediateText: 'Intermediate HTML level',
  strEmailContentTextOptionInfo:
    'Iterable automatically generates a plaintext version of the email on send. Only use this if you’d like to use a custom plaintext version instead.',
  strEmptyContentSMS: 'To preview your SMS message, add message content in the Settings area.',
  strEmptyContentEmail: 'To preview your email, go to Edit design and begin adding content',
  strEmptyContentInApp: 'To preview your in app, go to Edit design and begin adding content',
  strEmptyContentWebPush:
    'To preview your web push message, add title and body content in the Settings area',
  strEmptyContentWhatsApp:
    'To preview your WhatsApp message, go to Edit details and begin adding content.',
  strExpandUserData: 'Expand to see user data',
  strFontUrlHelpText: 'Insert full URL to hosted font file',
  strLocaleCount: _template('<%= localeCount %> <%= localeCount === 1 ? `locale` : `locales` %>'),
  strMediaUrlHelp:
    'Supports images and GIFs less than 900KB. Video, audio and other media types accepted, sizes may vary by carrier.',
  strMediaUrlInfoBannerMessage:
    'Only users with US and Canadian phone numbers will see this media. All others will see a link in the message body to access the media.',
  strCharacterCount: _template(
    '<%= charCount %> <%= charCount === 1 ? `character` : `characters` %>',
  ),
  strMessageCount: _template('<%= msgCount %> <%= msgCount === 1 ? `message` : `messages` %>'),
  strSegmentCount: _template(
    '<%= msgCount %> <%= typeOfSegment %> <%= msgCount === 1 ? `segment` : `segments` %>',
  ),
  strMessages: 'Messages',
  strMessageTypeHelp:
    'Determines unsubscribe eligibility. Visit Settings > Message Channels and Types to manage and add message types.',
  strMMSShortlinkMessage: 'Each user receives a personalized short link to view their media.',
  strNoDataFeeds: 'No data feeds have been added.',
  strNoAvailableDataFeeds:
    'No available data feeds. Add data feeds in Details for dynamic template generation.',
  strNoTemplateFoundDesc:
    'This template may belong to another project, or it may have been deleted.',
  strTemplateCorruptedDesc:
    'That locale may not have been created on this template, it may have been deleted, or it may be corrupted.',
  strNow: 'now',
  strOpenContentEditorSelector: 'Choose a content editor to start designing your message',
  strOptOutInfoMessage:
    'Opt-out text varies by country. Preview for accurate character count & message segments by user.',
  strRecipientsHelpText: 'Separate recipient emails with commas.',
  strRecipientsHelpTextUuid: 'Separate recipient emails (and/or user IDs) with commas.',
  strSelectEditorInfo:
    "You can switch between WYSIWYG and Side by Side later in template preferences, but Drag and Drop can't be switched once selected. Reminder: Do not add PII into the HTML of your content.",
  strSelectEditorInfoDisabled: 'The WYSIWYG editor is disabled in this project’s settings.',
  strSelectTemplateInfo:
    'Start from scratch or use one of the Drag and Drop compatible quick templates.',
  strSendTestAsRandomTitle: _template(
    'Send <%= isEmail ? `proof` : `test message` %> using random user data?',
  ),
  strSendTestAsRandomDesc: _template(
    "Send a test <%= isEmail ? `email` : `message` %> to yourself, with the message's data taken from a randomly selected user in this project. We cap message recipients at 50 to prevent accidentally sending to a production list.",
  ),
  strSendTestToInternalListTitle: _template(
    'Send test <%= isEmail ? `email` : `message` %> to internal list?',
  ),
  strSendTestToInternalListDesc: _template(
    'Send a test <%= isEmail ? `email` : `message` %> to an internal list to verify your <%= msgType %> configuration. We cap message recipients at 50 to prevent accidentally sending to a production list.',
  ),
  strSendTestToOtherTitle: _template(
    'Send test <%= isEmail ? `email` : `message` %> to another recipient?',
  ),
  strSendTestToOtherDesc: _template(
    'Send a test <%= isEmail ? `email` : `message` %> to a list of recipients entered below. We cap message recipients at 50 to prevent accidentally sending to a production list.',
  ),
  strSendTemplateSuccess: _template('<%= sendSubject %> sent to <%= recipient %>'),
  strSendTemplateSuccessAsRandom: _template(
    '<%= sendSubject %> sent to <%= uuidOrEmail %> using random user data from <%= listName %>',
  ),
  strSmsSmartOptInAssetTypeName: 'SMS opt-in link',
  strSmsSmartOptInDetailsDescriptionDefault: 'Description of where you would use this link',
  strSmsSmartOptInDetailsDisclaimer:
    'By signing up via text, you agree to receive recurring automated promotional and personalized marketing text messages (e.g. Marketing message) from {{brandName}} at the phone number used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg and data rates may apply. View ',
  strSmsSmartOptInDetailsDisclaimerHideInfoText: 'Hide full disclaimer text',
  strSmsSmartOptInDetailsDisclaimerShowInfoText: 'Show full disclaimer text',
  strSmsSmartOptInDetailsDisclaimerTermsText: 'Terms of Service',
  strSmsSmartOptInDetailsDisclaimerPrivacyText: 'Privacy Policy.',
  strSmsSmartOptInDocumentationLinkUrl: 'https://support.iterable.com/hc/articles/10870034844308',
  strSmsSmartOptInDetailsHeaderNeutralBannerBody:
    'Copy the SMS opt-in link and recommended SMS disclaimer and add them to your message. When a user taps on the link, their messaging app will open with a prefilled SMS opt-in text.',
  strSmsSmartOptInDetailsHeaderNeutralBannerLink: 'Learn more',
  strSmsSmartOptInDetailsHeaderNeutralBannerTitle:
    '✂️ Add these custom SMS opt-in link and disclaimer to your message',
  strSmsSmartOptInFormBrandNameHelpText:
    'Customize your disclaimer and opt-in text with the brand name of your choice',
  strSmsSmartOptInFormErrorBannerText:
    'Oops! Please correct the highlighted fields and save again to update the',
  strSmsSmartOptInFormHeroBannerContent:
    'Generate a special link to include in your campaign message. When a user taps it, it will auto-populate an SMS they can send to opt-in to your list.',
  strSmsSmartOptInFormMessageTypeHelpText:
    'This is the SMS message type that users are opting in to',
  strSmsSmartOptInFormSenderHelpText:
    'This is the SMS sender that the opt-in text is being sent to',
  strTextMessage: 'Text message',
  strTypeMessage: 'Type message...',
  strUnsavedChanges: 'There are unsaved changes',
  strUnsavedChangesSave: 'This template has been edited. Do you want to save your changes?',
  strUnsetText: 'Not set',
  strUserDataSummary: 'User data summary',
  strViewTemplatePermissionDesc:
    'You do not have permission to view this template. An admin can change this.',
  strWarningHtmlSwitch:
    'Switching editors will discard unsaved changes. If you do not want to discard, save your template before switching.',
  templateInformation: 'Template Information',
  tooltipArchivedPlacement: 'Placement has been archived',
  tooltipDragDrop: 'A drag-and-drop interface for arranging modular template elements',
  tooltipManageBaseTemplatesPermission:
    'You do not have permissions to manage templates. Please contact your admin to get permissions.',
  tooltipMaxCharLimit: 'Message could be truncated on some devices.',
  tooltipMmsNotAvailable: 'Please contact your CSM to purchase MMS.',
  tooltipSideBySide: 'A two-column interface for editing and previewing HTML',
  tooltipValidatingContent: 'Validating content',
  tooltipViewOnlyPermission:
    'You do not have permissions to edit campaigns or experiments. Please contact your admin to get permissions.',
  tooltipViewAndDraftPermission:
    'You do not have permissions to activate campaigns or experiments. Please contact your admin to get permissions.',
  tooltipUserProfilePermission:
    'You do not have permissions to view User profiles & data. Please contact your admin to get permissions.',
  tooltipWysiwyg: 'A familiar, point-and-click text editor',
  ucs2Encoding: 'UCS-2 Encoding',
  validationError: 'Error validating content. Please try again later.',
  whatsAppTemplateReviewButtonTooltipContent: 'Fix errors to submit for approval',
  whatsAppTemplateReviewButtonNoSender: 'Select a sender to submit for approval',
} as const;
